var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixRestaurantsOperationsV1Operation from '@wix/ambassador-restaurants-operations-v1-operation/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
let __verbose = false;
function __log(...args) {
    __verbose && console.log(...args);
}
function __inspect(obj) {
    return obj;
}
export const __debug = {
    verboseLogging: {
        on: () => (__verbose = true),
        off: () => (__verbose = false),
    },
};
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
/** Scheduling type enum. */
export var SchedulingType;
(function (SchedulingType) {
    /** Unknown scheduling type. */
    SchedulingType["UNKNOWN_SCHEDULING"] = "UNKNOWN_SCHEDULING";
    /**
     * Asap scheduling type.
     * Refers to scheduling orders for as soon as possible handling or for a future time.
     */
    SchedulingType["ASAP"] = "ASAP";
    /**
     * Preorder scheduling type.
     * Refers to scheduling orders for a future time only.
     */
    SchedulingType["PREORDER"] = "PREORDER";
})(SchedulingType || (SchedulingType = {}));
/** Preparation time type enum. */
export var PreparationTimeType;
(function (PreparationTimeType) {
    /** Unknown preparation time type. */
    PreparationTimeType["UNKNOWN_PREPARATION_TIME"] = "UNKNOWN_PREPARATION_TIME";
    /**
     * Max preparation time type.
     * Refers to a preparation time that is bounded by a maximum time.
     */
    PreparationTimeType["MAX"] = "MAX";
    /**
     * Range preparation time type.
     * Refers to a preparation time that is bounded by a range of times.
     */
    PreparationTimeType["RANGE"] = "RANGE";
})(PreparationTimeType || (PreparationTimeType = {}));
/** Time unit enum. */
export var TimeUnit;
(function (TimeUnit) {
    /** Unknown time unit. */
    TimeUnit["UNKNOWN_TIME_UNIT"] = "UNKNOWN_TIME_UNIT";
    /** Minutes time unit. */
    TimeUnit["MINUTES"] = "MINUTES";
    /** Hours time unit. */
    TimeUnit["HOURS"] = "HOURS";
    /** Days time unit. */
    TimeUnit["DAYS"] = "DAYS";
})(TimeUnit || (TimeUnit = {}));
/** Asap preorder type enum. */
export var AsapPreorderType;
(function (AsapPreorderType) {
    /** Unknown asap preorder type. */
    AsapPreorderType["UNKNOWN_ASAP_PREORDER"] = "UNKNOWN_ASAP_PREORDER";
    /**
     * No preorder type.
     * Refers to not allowing to preorder.
     */
    AsapPreorderType["NO_PREORDER"] = "NO_PREORDER";
    /**
     * Business days preorder type.
     * Refers to allowing to preorder for a maximum number of business days in advance.
     */
    AsapPreorderType["BUSINESS_DAYS_PREORDER"] = "BUSINESS_DAYS_PREORDER";
})(AsapPreorderType || (AsapPreorderType = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    /** Monday. */
    DayOfWeek["MON"] = "MON";
    /** Tuesday. */
    DayOfWeek["TUE"] = "TUE";
    /** Wednesday. */
    DayOfWeek["WED"] = "WED";
    /** Thursday. */
    DayOfWeek["THU"] = "THU";
    /** Friday. */
    DayOfWeek["FRI"] = "FRI";
    /** Saturday. */
    DayOfWeek["SAT"] = "SAT";
    /** Sunday. */
    DayOfWeek["SUN"] = "SUN";
})(DayOfWeek || (DayOfWeek = {}));
/** The preorder method type enum. */
export var MethodType;
(function (MethodType) {
    /** Unknown preorder method type. */
    MethodType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    /**
     * Time bounded preorder method type.
     * Refers to allowing to preorder for a time bounded by a minimum and maximum time in advance.
     */
    MethodType["TIME_BOUNDED"] = "TIME_BOUNDED";
    /**
     * Weekly schedule preorder method type.
     * Refers to allowing to preorder by a weekly schedule given a cutoff time.
     */
    MethodType["WEEKLY_SCHEDULE"] = "WEEKLY_SCHEDULE";
})(MethodType || (MethodType = {}));
/** The fulfillment times type enum. */
export var FulfillmentTimesType;
(function (FulfillmentTimesType) {
    /** Unknown fulfillment times type. */
    FulfillmentTimesType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    /**
     * Time windows fulfillment times type.
     * Refers to displaying fulfillment times as time windows.
     */
    FulfillmentTimesType["TIME_WINDOWS"] = "TIME_WINDOWS";
})(FulfillmentTimesType || (FulfillmentTimesType = {}));
/** Online ordering status enum. */
export var OnlineOrderingStatusType;
(function (OnlineOrderingStatusType) {
    /** Online ordering status is undefined. */
    OnlineOrderingStatusType["UNDEFINED_ONLINE_ORDERING_STATUS"] = "UNDEFINED_ONLINE_ORDERING_STATUS";
    /** Online ordering is enabled. */
    OnlineOrderingStatusType["ENABLED"] = "ENABLED";
    /** Online ordering is disabled. */
    OnlineOrderingStatusType["DISABLED"] = "DISABLED";
    /** Online ordering is paused until some timestamp. */
    OnlineOrderingStatusType["PAUSED_UNTIL"] = "PAUSED_UNTIL";
})(OnlineOrderingStatusType || (OnlineOrderingStatusType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    /** State */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    /** County */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    /** City/town */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    /** Neighborhood/quarter */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    /** Street/block */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
    SubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionType || (SubdivisionType = {}));
/** The fulfillment type enum. */
export var FulfillmentType;
(function (FulfillmentType) {
    /** Undefined fulfillment type. */
    FulfillmentType["UNDEFINED_FULFILLMENT_TYPE"] = "UNDEFINED_FULFILLMENT_TYPE";
    /** Pickup fulfillment. */
    FulfillmentType["PICKUP"] = "PICKUP";
    /** Delivery fulfillment. */
    FulfillmentType["DELIVERY"] = "DELIVERY";
})(FulfillmentType || (FulfillmentType = {}));
/** The fulfillment time type enum. */
export var FulfillmentTimeType;
(function (FulfillmentTimeType) {
    /** Undefined fulfillment time type. */
    FulfillmentTimeType["UNDEFINED_FULFILLMENT_TIME"] = "UNDEFINED_FULFILLMENT_TIME";
    /** The fulfillment time is bounded by a maximum time. */
    FulfillmentTimeType["MAX_TIME"] = "MAX_TIME";
    /** The fulfillment time is bounded by a range of times. */
    FulfillmentTimeType["DURATION_RANGE"] = "DURATION_RANGE";
})(FulfillmentTimeType || (FulfillmentTimeType = {}));
/** The fulfillment times display type enum. */
export var FulfillmentTimesDisplayType;
(function (FulfillmentTimesDisplayType) {
    /** Undefined fulfillment times display type. */
    FulfillmentTimesDisplayType["UNDEFINED_FULFILLMENT_TIMES_DISPLAY"] = "UNDEFINED_FULFILLMENT_TIMES_DISPLAY";
    /** The fulfillment times will be displayed as a list of time windows. */
    FulfillmentTimesDisplayType["TIME_WINDOWS"] = "TIME_WINDOWS";
})(FulfillmentTimesDisplayType || (FulfillmentTimesDisplayType = {}));
export var FeeType;
(function (FeeType) {
    /** Undefined fee type. */
    FeeType["UNDEFINED_FEE_TYPE"] = "UNDEFINED_FEE_TYPE";
    /** Single price value. */
    FeeType["VALUE"] = "VALUE";
    /** Range of prices value. */
    FeeType["RANGE"] = "RANGE";
})(FeeType || (FeeType = {}));
/** Min order price enum. */
export var MinOrderPriceType;
(function (MinOrderPriceType) {
    /** Undefined min order price type. */
    MinOrderPriceType["UNDEFINED_MIN_ORDER_PRICE_TYPE"] = "UNDEFINED_MIN_ORDER_PRICE_TYPE";
    /** Single min order price value. */
    MinOrderPriceType["PRICE_VALUE"] = "PRICE_VALUE";
    /** Range of min order price values. */
    MinOrderPriceType["PRICE_RANGE"] = "PRICE_RANGE";
})(MinOrderPriceType || (MinOrderPriceType = {}));
/** Where the extra text should be displayed: before, after or instead of the actual address. */
export var PlacementType;
(function (PlacementType) {
    PlacementType["BEFORE"] = "BEFORE";
    PlacementType["AFTER"] = "AFTER";
    PlacementType["REPLACE"] = "REPLACE";
})(PlacementType || (PlacementType = {}));
/** Enumerates the days of the week. */
export var V4DayOfWeek;
(function (V4DayOfWeek) {
    V4DayOfWeek["MONDAY"] = "MONDAY";
    V4DayOfWeek["TUESDAY"] = "TUESDAY";
    V4DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    V4DayOfWeek["THURSDAY"] = "THURSDAY";
    V4DayOfWeek["FRIDAY"] = "FRIDAY";
    V4DayOfWeek["SATURDAY"] = "SATURDAY";
    V4DayOfWeek["SUNDAY"] = "SUNDAY";
})(V4DayOfWeek || (V4DayOfWeek = {}));
export var ResolutionMethod;
(function (ResolutionMethod) {
    ResolutionMethod["QUERY_PARAM"] = "QUERY_PARAM";
    ResolutionMethod["SUBDOMAIN"] = "SUBDOMAIN";
    ResolutionMethod["SUBDIRECTORY"] = "SUBDIRECTORY";
})(ResolutionMethod || (ResolutionMethod = {}));
const _createOperationRequest = {};
const _createOperationResponse = {};
const _deleteOperationRequest = {};
const _deleteOperationResponse = {};
const _fulfillmentOption = { pickupOptions: '_pickupDetails' };
const _getExpectedFulfillmentSelectionRequest = {
    deliveryAddress: 'wix.common.Address',
};
const _getExpectedFulfillmentSelectionResponse = {
    expectedFulfillmentSelections: '_fulfillmentOption',
};
const _getOperationRequest = {};
const _getOperationResponse = {};
const _listAvailableDatesInRangeRequest = {
    deliveryAddress: 'wix.common.Address',
};
const _listAvailableDatesInRangeResponse = {};
const _listAvailableFulfillmentOptionsRequest = {
    deliveryAddress: 'wix.common.Address',
};
const _listAvailableFulfillmentOptionsResponse = {
    fulfillmentOptions: '_fulfillmentOption',
};
const _listAvailableTimeSlotsForDateRequest = {
    deliveryAddress: 'wix.common.Address',
};
const _listAvailableTimeSlotsForDateResponse = {};
const _listFirstAvailableTimeSlotForFulfillmentTypesRequest = {
    deliveryAddress: 'wix.common.Address',
};
const _listFirstAvailableTimeSlotForFulfillmentTypesResponse = {};
const _listOperationsRequest = {};
const _listOperationsResponse = {};
const _pickupDetails = { address: 'wix.common.Address' };
const _queryOperationRequest = {};
const _queryOperationResponse = {};
const _updateOperationRequest = {};
const _updateOperationResponse = {};
/**
 * Creates a new operation.
 * @param operation - Operation to create.
 * @internal
 * @documentationMaturity preview
 * @requiredField operation
 * @adminMethod
 * @returns The created operation.
 */
export function createOperation(operation) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { operation: '$[0]' };
        const responseTransformation = '$.operation';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createOperationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['operation']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createOperationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['operation']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([operation]);
        const reqOpts = ambassadorWixRestaurantsOperationsV1Operation.createOperation(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"CreateOperation" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'operation',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves an operation.
 * @param operationId - The ID of the operation to retrieve.
 * @internal
 * @documentationMaturity preview
 * @requiredField operationId
 * @returns The retrieved operation.
 */
export function getOperation(operationId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { operationId: '$[0]' };
        const responseTransformation = '$.operation';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getOperationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getOperationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['operation']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([operationId]);
        const reqOpts = ambassadorWixRestaurantsOperationsV1Operation.getOperation(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"GetOperation" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'operationId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates an operation.
 * Partial updates are supported, except for the scheduling field.
 * Each time the operation is updated, the `revision` increments by 1.
 * The existing `revision` must be included in the request when updating the operation.
 * This ensures you're updating the latest version of the operation and it prevents unintended overwrites.
 * @param _id - The ID of the operation.
 * @internal
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField operation
 * @requiredField operation.revision
 * @adminMethod
 * @returns The updated operation.
 */
export function updateOperation(_id, operation, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            operation: { '*': '$[1]', id: '$[0]' },
            mask: '$[2].mask',
        };
        const responseTransformation = '$.operation';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateOperationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['operation']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateOperationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['operation']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, operation, options]);
        const reqOpts = ambassadorWixRestaurantsOperationsV1Operation.updateOperation(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"UpdateOperation" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'operation',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes an operation.
 * @param operationId - The ID of the operation to delete.
 * @internal
 * @documentationMaturity preview
 * @requiredField operationId
 * @adminMethod
 */
export function deleteOperation(operationId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { operationId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteOperationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteOperationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([operationId]);
        const reqOpts = ambassadorWixRestaurantsOperationsV1Operation.deleteOperation(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"DeleteOperation" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'operationId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of operations by a given query.
 * To learn how to query operations, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 * Up to 100 operations can be returned per request.
 * @internal
 * @documentationMaturity preview
 */
export function queryOperation() {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.operations',
        pagingMetadata: '$.metadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[0];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryOperationRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryOperationResponse,
        depSchemas: {},
        fqdnTransformation: {
            paths: [...['Array#operations']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixRestaurantsOperationsV1Operation.queryOperation(payload);
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'CURSOR',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/**
 * Retrieves a list of operations.
 * Up to 100 operations can be returned per request.
 * TODO: support pagination
 * @internal
 * @documentationMaturity preview
 */
export function listOperations() {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {};
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[0];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listOperationsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listOperationsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#operations']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([]);
        const reqOpts = ambassadorWixRestaurantsOperationsV1Operation.listOperations(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"ListOperations" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, []);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of available fulfillment options.
 * What makes a fulfillment option available is whether it's possible to submit an order given the scheduling configurations and the fulfillment method's availability.
 * When a `delivery_address` is not provided in the input, our system retrieves a list encompassing all types of fulfillment methods.
 * Conversely, if a `delivery_address` is given, the response may includes non-delivery fulfillment options along with delivery fulfillment methods that are applicable to the given address, ensuring the address falls within the defined delivery area of these methods.
 * @param operationId - The ID of the operation.
 * The returned fulfillment options will belong to this operation.
 * @internal
 * @documentationMaturity preview
 * @requiredField operationId
 */
export function listAvailableFulfillmentOptions(operationId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            operationId: '$[0]',
            deliveryAddress: '$[1].deliveryAddress',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listAvailableFulfillmentOptionsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listAvailableFulfillmentOptionsResponse,
            depSchemas: { _fulfillmentOption, _pickupDetails },
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([operationId, options]);
        const reqOpts = ambassadorWixRestaurantsOperationsV1Operation.listAvailableFulfillmentOptions(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"ListAvailableFulfillmentOptions" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'operationId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of available time slots for each fulfillment type.
 * Each time slot will be the first available time slot for the given fulfillment type.
 * @param operationId - The ID of the operation.
 * The returned fulfillment options will belong to this operation.
 * @internal
 * @documentationMaturity preview
 * @requiredField operationId
 */
export function listFirstAvailableTimeSlotForFulfillmentTypes(operationId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            operationId: '$[0]',
            deliveryAddress: '$[1].deliveryAddress',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listFirstAvailableTimeSlotForFulfillmentTypesRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listFirstAvailableTimeSlotForFulfillmentTypesResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([operationId, options]);
        const reqOpts = ambassadorWixRestaurantsOperationsV1Operation.listFirstAvailableTimeSlotForFulfillmentTypes(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"ListFirstAvailableTimeSlotForFulfillmentTypes" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'operationId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of the available time slots for a given date.
 * @param operationId - The ID of the operation.
 * The returned fulfillment options will belong to this operation.
 * @internal
 * @documentationMaturity preview
 * @requiredField operationId
 * @requiredField options.date
 * @requiredField options.date.day
 * @requiredField options.date.month
 * @requiredField options.date.year
 */
export function listAvailableTimeSlotsForDate(operationId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            operationId: '$[0]',
            deliveryAddress: '$[1].deliveryAddress',
            date: '$[1].date',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listAvailableTimeSlotsForDateRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listAvailableTimeSlotsForDateResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([operationId, options]);
        const reqOpts = ambassadorWixRestaurantsOperationsV1Operation.listAvailableTimeSlotsForDate(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"ListAvailableTimeSlotsForDate" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'operationId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of the available dates in a given time range.
 * A date is considered available if it has at least one available time slot.
 * @param operationId - The ID of the operation.
 * The returned fulfillment options will belong to this operation.
 * @internal
 * @documentationMaturity preview
 * @requiredField operationId
 * @requiredField options.from
 * @requiredField options.until
 */
export function listAvailableDatesInRange(operationId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            operationId: '$[0]',
            deliveryAddress: '$[1].deliveryAddress',
            from: '$[1].from',
            until: '$[1].until',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listAvailableDatesInRangeRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listAvailableDatesInRangeResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([operationId, options]);
        const reqOpts = ambassadorWixRestaurantsOperationsV1Operation.listAvailableDatesInRange(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"ListAvailableDatesInRange" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'operationId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of the fulfillment options that will be available given the provided filters.
 * TODO: probably rename, the implementation took a different direction than the name suggests
 * @param operationId - The id of the operation. The returned fulfillment will belong to this operation.
 * @internal
 * @documentationMaturity preview
 * @requiredField operationId
 * @requiredField options.fulfilmentType
 */
export function getExpectedFulfillmentSelection(operationId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            operationId: '$[0]',
            deliveryAddress: '$[1].deliveryAddress',
            timeslotStartTime: '$[1].timeslotStartTime',
            timeslotEndTime: '$[1].timeslotEndTime',
            fulfilmentType: '$[1].fulfilmentType',
            canSubmitOrderForNow: '$[1].canSubmitOrderForNow',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getExpectedFulfillmentSelectionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getExpectedFulfillmentSelectionResponse,
            depSchemas: { _fulfillmentOption, _pickupDetails },
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([operationId, options]);
        const reqOpts = ambassadorWixRestaurantsOperationsV1Operation.getExpectedFulfillmentSelection(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"GetExpectedFulfillmentSelection" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'operationId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=restaurants-operations-v1-operation.universal.js.map